<template>
    <div>
        <a-form-item label="门店选择" :labelCol="{span: labelSpan}" :wrapperCol="{span: wrapperSpan}">
            <a-select @change="onChange" placeholder="请选择" :options="shopList" v-decorator="['shop',{rules:[{required: true, message: '请选择'}]}]"></a-select>
        </a-form-item>
    </div>
</template>
<script>
    /**
     * 备注组件
     * @prop {Boolean} labelSpan 文字宽度
     * @prop {Boolean} wrapperSpan 内容宽度
     * @prop {String} help 备注类型必填提示
     * @prop {String} operateCode 备注类型必填提示
     * @prop {Boolean} disabled 禁用
     */
    export default {
        data() {
            return {
                shopList: []
            }
        },
        props: {
            labelSpan: {type: Number},
            wrapperSpan: {type: Number},
            isOrigal: {type: Boolean, default: false},
            shops: {type: Array, default: () => []}
        },
        watch: {
            shops(val) {
                this.getShopList();
            }
        },
        methods: {
            /**
             * @getShopList 获取门店列表
             */
            getShopList() {
                this.shopList = this.$utils.deepClone(this.shops);
                let shopIdList = this.$userInfoTool.getUser().shopIdList;
                if (shopIdList.find(el => el == -1)) {
                    this.shopList.unshift({
                        shopId: -1,
                        shopName: "总平台"
                    })
                }
                this.shopList.forEach((item, index) => {
                    item.id = item.shopId;
                    item.name = item.shopName;
                    item.label = item.shopName;
                    item.value = JSON.stringify(item);
                });
            },
            onChange(e) {
                this.shopList.forEach(shop => {
                    if(shop.id === e) {
                        this.$parent.form.setFieldsValue({'shop': shop});
                    }
                })
            },
        },
        mounted() {
            this.getShopList();
        }
    }
</script>